/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PetCalendarEventModel,
  PetCommentModel,
  PetFormConfigurationResponseModel,
  PetImageModel,
  PetPrescriptionModel,
  PetProfileModel,
  PetProfileResultsModel,
  PetV2FormConfigurationResponseModel,
} from '../models';
import {
    PetCalendarEventModelFromJSON,
    PetCalendarEventModelToJSON,
    PetCommentModelFromJSON,
    PetCommentModelToJSON,
    PetFormConfigurationResponseModelFromJSON,
    PetFormConfigurationResponseModelToJSON,
    PetImageModelFromJSON,
    PetImageModelToJSON,
    PetPrescriptionModelFromJSON,
    PetPrescriptionModelToJSON,
    PetProfileModelFromJSON,
    PetProfileModelToJSON,
    PetProfileResultsModelFromJSON,
    PetProfileResultsModelToJSON,
    PetV2FormConfigurationResponseModelFromJSON,
    PetV2FormConfigurationResponseModelToJSON,
} from '../models';

export interface PetProfileApiCreatePetCommentRequest {
    id: number;
    petCommentModel: PetCommentModel;
    xChewyAuthIDToken?: string;
    authorization?: string;
}

export interface PetProfileApiCreatePetProfileRequest {
    petProfileModel: PetProfileModel;
    xChewyAuthIDToken?: string;
    authorization?: string;
}

export interface PetProfileApiDeletePetProfileRequest {
    id: number;
    statusReason: DeletePetProfileStatusReasonEnum;
    xChewyAuthIDToken?: string;
    authorization?: string;
    cookie?: string;
}

export interface PetProfileApiGetPetCalendarEventsRequest {
    id: number;
    xChewyAuthIDToken?: string;
    authorization?: string;
    daysAhead?: number;
    startDate?: Date;
}

export interface PetProfileApiGetPetFormConfigurationRequest {
    xChewyAuthIDToken?: string;
    authorization?: string;
    petTypeId?: number;
    petProfileId?: number;
    usecase?: GetPetFormConfigurationUsecaseEnum;
}

export interface PetProfileApiGetPetPrescriptionsRequest {
    id: number;
    xChewyAuthIDToken?: string;
    authorization?: string;
    size?: number;
    page?: number;
    sortBy?: string;
}

export interface PetProfileApiGetPetProfileRequest {
    id: number;
    xChewyAuthIDToken?: string;
    authorization?: string;
    includeOwnerName?: boolean;
}

export interface PetProfileApiGetPetProfilesRequest {
    xChewyAuthIDToken?: string;
    authorization?: string;
    start?: number;
    page?: number;
    limit?: number;
    pharmacyEligibleOnly?: boolean;
    vetDietEligibleOnly?: boolean;
    includeOwnerName?: boolean;
    petStatus?: GetPetProfilesPetStatusEnum;
    excludePetStatus?: GetPetProfilesExcludePetStatusEnum;
}

export interface PetProfileApiGetPetV2FormConfigurationRequest {
    xChewyAuthIDToken: string;
    xChewyAuthAccessToken: string;
    usecase?: GetPetV2FormConfigurationUsecaseEnum;
    petProfileId?: number;
}

export interface PetProfileApiUpdatePetProfileRequest {
    id: number;
    petProfileModel: PetProfileModel;
    xChewyAuthIDToken?: string;
    authorization?: string;
}

export interface PetProfileApiUploadPetImageRequest {
    petImageModel: PetImageModel;
    xChewyAuthIDToken?: string;
    authorization?: string;
}

export interface PetProfileApiUploadPetImageV2Request {
    body: any;
    xChewyAuthIDToken?: string;
    authorization?: string;
}

/**
 * 
 */
export class PetProfileApi extends runtime.BaseAPI {

    /**
     * Create a comment for a given pet
     * Create Pet Comment
     */
    async createPetCommentRaw(requestParameters: PetProfileApiCreatePetCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetCommentModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createPetComment.');
        }

        if (requestParameters.petCommentModel === null || requestParameters.petCommentModel === undefined) {
            throw new runtime.RequiredError('petCommentModel','Required parameter requestParameters.petCommentModel was null or undefined when calling createPetComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}/comments`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PetCommentModelToJSON(requestParameters.petCommentModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetCommentModelFromJSON(jsonValue));
    }

    /**
     * Create a comment for a given pet
     * Create Pet Comment
     */
    async createPetComment(requestParameters: PetProfileApiCreatePetCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetCommentModel> {
        const response = await this.createPetCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a pet profile
     * Create Pet Profile
     */
    async createPetProfileRaw(requestParameters: PetProfileApiCreatePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetProfileModel>> {
        if (requestParameters.petProfileModel === null || requestParameters.petProfileModel === undefined) {
            throw new runtime.RequiredError('petProfileModel','Required parameter requestParameters.petProfileModel was null or undefined when calling createPetProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PetProfileModelToJSON(requestParameters.petProfileModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetProfileModelFromJSON(jsonValue));
    }

    /**
     * Create a pet profile
     * Create Pet Profile
     */
    async createPetProfile(requestParameters: PetProfileApiCreatePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetProfileModel> {
        const response = await this.createPetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a pet profile for a given pet ID
     * Delete Pet Profile
     */
    async deletePetProfileRaw(requestParameters: PetProfileApiDeletePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePetProfile.');
        }

        if (requestParameters.statusReason === null || requestParameters.statusReason === undefined) {
            throw new runtime.RequiredError('statusReason','Required parameter requestParameters.statusReason was null or undefined when calling deletePetProfile.');
        }

        const queryParameters: any = {};

        if (requestParameters.statusReason !== undefined) {
            queryParameters['statusReason'] = requestParameters.statusReason;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.cookie !== undefined && requestParameters.cookie !== null) {
            headerParameters['Cookie'] = String(requestParameters.cookie);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a pet profile for a given pet ID
     * Delete Pet Profile
     */
    async deletePetProfile(requestParameters: PetProfileApiDeletePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePetProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Get calendar events for a given pet
     * Get Pet Calendar Events
     */
    async getPetCalendarEventsRaw(requestParameters: PetProfileApiGetPetCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetCalendarEventModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPetCalendarEvents.');
        }

        const queryParameters: any = {};

        if (requestParameters.daysAhead !== undefined) {
            queryParameters['daysAhead'] = requestParameters.daysAhead;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}/calendar-events`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetCalendarEventModelFromJSON));
    }

    /**
     * Get calendar events for a given pet
     * Get Pet Calendar Events
     */
    async getPetCalendarEvents(requestParameters: PetProfileApiGetPetCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetCalendarEventModel>> {
        const response = await this.getPetCalendarEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve form configuration based on pet type or pet profile ID
     * Get Pet Form Configuration
     */
    async getPetFormConfigurationRaw(requestParameters: PetProfileApiGetPetFormConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetFormConfigurationResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.petTypeId !== undefined) {
            queryParameters['petTypeId'] = requestParameters.petTypeId;
        }

        if (requestParameters.petProfileId !== undefined) {
            queryParameters['petProfileId'] = requestParameters.petProfileId;
        }

        if (requestParameters.usecase !== undefined) {
            queryParameters['usecase'] = requestParameters.usecase;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/form`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetFormConfigurationResponseModelFromJSON(jsonValue));
    }

    /**
     * Retrieve form configuration based on pet type or pet profile ID
     * Get Pet Form Configuration
     */
    async getPetFormConfiguration(requestParameters: PetProfileApiGetPetFormConfigurationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetFormConfigurationResponseModel> {
        const response = await this.getPetFormConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescriptions for a given pet
     * Get Pet Prescriptions
     */
    async getPetPrescriptionsRaw(requestParameters: PetProfileApiGetPetPrescriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetPrescriptionModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPetPrescriptions.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}/rx`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetPrescriptionModelFromJSON));
    }

    /**
     * Get prescriptions for a given pet
     * Get Pet Prescriptions
     */
    async getPetPrescriptions(requestParameters: PetProfileApiGetPetPrescriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetPrescriptionModel>> {
        const response = await this.getPetPrescriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a pet profile for a given pet ID
     * Get Pet Profile
     */
    async getPetProfileRaw(requestParameters: PetProfileApiGetPetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetProfileModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPetProfile.');
        }

        const queryParameters: any = {};

        if (requestParameters.includeOwnerName !== undefined) {
            queryParameters['includeOwnerName'] = requestParameters.includeOwnerName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetProfileModelFromJSON(jsonValue));
    }

    /**
     * Get a pet profile for a given pet ID
     * Get Pet Profile
     */
    async getPetProfile(requestParameters: PetProfileApiGetPetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetProfileModel> {
        const response = await this.getPetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pet profiles
     * Get Pet Profiles
     */
    async getPetProfilesRaw(requestParameters: PetProfileApiGetPetProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetProfileResultsModel>> {
        const queryParameters: any = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.pharmacyEligibleOnly !== undefined) {
            queryParameters['pharmacyEligibleOnly'] = requestParameters.pharmacyEligibleOnly;
        }

        if (requestParameters.vetDietEligibleOnly !== undefined) {
            queryParameters['vetDietEligibleOnly'] = requestParameters.vetDietEligibleOnly;
        }

        if (requestParameters.includeOwnerName !== undefined) {
            queryParameters['includeOwnerName'] = requestParameters.includeOwnerName;
        }

        if (requestParameters.petStatus !== undefined) {
            queryParameters['petStatus'] = requestParameters.petStatus;
        }

        if (requestParameters.excludePetStatus !== undefined) {
            queryParameters['excludePetStatus'] = requestParameters.excludePetStatus;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetProfileResultsModelFromJSON(jsonValue));
    }

    /**
     * Get pet profiles
     * Get Pet Profiles
     */
    async getPetProfiles(requestParameters: PetProfileApiGetPetProfilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetProfileResultsModel> {
        const response = await this.getPetProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve form configuration based on pet type or pet profile ID
     * Get Pet V2 Form Configuration
     */
    async getPetV2FormConfigurationRaw(requestParameters: PetProfileApiGetPetV2FormConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetV2FormConfigurationResponseModel>> {
        if (requestParameters.xChewyAuthIDToken === null || requestParameters.xChewyAuthIDToken === undefined) {
            throw new runtime.RequiredError('xChewyAuthIDToken','Required parameter requestParameters.xChewyAuthIDToken was null or undefined when calling getPetV2FormConfiguration.');
        }

        if (requestParameters.xChewyAuthAccessToken === null || requestParameters.xChewyAuthAccessToken === undefined) {
            throw new runtime.RequiredError('xChewyAuthAccessToken','Required parameter requestParameters.xChewyAuthAccessToken was null or undefined when calling getPetV2FormConfiguration.');
        }

        const queryParameters: any = {};

        if (requestParameters.usecase !== undefined) {
            queryParameters['usecase'] = requestParameters.usecase;
        }

        if (requestParameters.petProfileId !== undefined) {
            queryParameters['petProfileId'] = requestParameters.petProfileId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.xChewyAuthAccessToken !== undefined && requestParameters.xChewyAuthAccessToken !== null) {
            headerParameters['X-Chewy-Auth-Access-Token'] = String(requestParameters.xChewyAuthAccessToken);
        }

        const response = await this.request({
            path: `/api/petprofile/v2/pets/form`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetV2FormConfigurationResponseModelFromJSON(jsonValue));
    }

    /**
     * Retrieve form configuration based on pet type or pet profile ID
     * Get Pet V2 Form Configuration
     */
    async getPetV2FormConfiguration(requestParameters: PetProfileApiGetPetV2FormConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetV2FormConfigurationResponseModel> {
        const response = await this.getPetV2FormConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a pet profile for a given pet ID
     * Update Pet Profile
     */
    async updatePetProfileRaw(requestParameters: PetProfileApiUpdatePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetProfileModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePetProfile.');
        }

        if (requestParameters.petProfileModel === null || requestParameters.petProfileModel === undefined) {
            throw new runtime.RequiredError('petProfileModel','Required parameter requestParameters.petProfileModel was null or undefined when calling updatePetProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PetProfileModelToJSON(requestParameters.petProfileModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetProfileModelFromJSON(jsonValue));
    }

    /**
     * Update a pet profile for a given pet ID
     * Update Pet Profile
     */
    async updatePetProfile(requestParameters: PetProfileApiUpdatePetProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetProfileModel> {
        const response = await this.updatePetProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a pet image
     * Upload Pet Image
     */
    async uploadPetImageRaw(requestParameters: PetProfileApiUploadPetImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetImageModel>> {
        if (requestParameters.petImageModel === null || requestParameters.petImageModel === undefined) {
            throw new runtime.RequiredError('petImageModel','Required parameter requestParameters.petImageModel was null or undefined when calling uploadPetImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pet-images`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PetImageModelToJSON(requestParameters.petImageModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetImageModelFromJSON(jsonValue));
    }

    /**
     * Upload a pet image
     * Upload Pet Image
     */
    async uploadPetImage(requestParameters: PetProfileApiUploadPetImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetImageModel> {
        const response = await this.uploadPetImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a pet image using application/octet-stream
     * Upload Pet Image
     */
    async uploadPetImageV2Raw(requestParameters: PetProfileApiUploadPetImageV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetImageModel>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling uploadPetImageV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (requestParameters.xChewyAuthIDToken !== undefined && requestParameters.xChewyAuthIDToken !== null) {
            headerParameters['X-Chewy-Auth-ID-Token'] = String(requestParameters.xChewyAuthIDToken);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        const response = await this.request({
            path: `/api/petprofile/v1/pet-binary-images`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetImageModelFromJSON(jsonValue));
    }

    /**
     * Upload a pet image using application/octet-stream
     * Upload Pet Image
     */
    async uploadPetImageV2(requestParameters: PetProfileApiUploadPetImageV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetImageModel> {
        const response = await this.uploadPetImageV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const DeletePetProfileStatusReasonEnum = {
    Unknown: 'UNKNOWN',
    Deceased: 'DECEASED',
    SwitchedRetailers: 'SWITCHED_RETAILERS',
    Other: 'OTHER'
} as const;
export type DeletePetProfileStatusReasonEnum = typeof DeletePetProfileStatusReasonEnum[keyof typeof DeletePetProfileStatusReasonEnum];
/**
 * @export
 */
export const GetPetFormConfigurationUsecaseEnum = {
    Basic: 'basic',
    Pharmacy: 'pharmacy',
    VetDiet: 'vetDiet',
    Cwav: 'cwav',
    Insurance: 'insurance',
    Test: 'test'
} as const;
export type GetPetFormConfigurationUsecaseEnum = typeof GetPetFormConfigurationUsecaseEnum[keyof typeof GetPetFormConfigurationUsecaseEnum];
/**
 * @export
 */
export const GetPetProfilesPetStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Deleted: 'DELETED'
} as const;
export type GetPetProfilesPetStatusEnum = typeof GetPetProfilesPetStatusEnum[keyof typeof GetPetProfilesPetStatusEnum];
/**
 * @export
 */
export const GetPetProfilesExcludePetStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Deleted: 'DELETED'
} as const;
export type GetPetProfilesExcludePetStatusEnum = typeof GetPetProfilesExcludePetStatusEnum[keyof typeof GetPetProfilesExcludePetStatusEnum];
/**
 * @export
 */
export const GetPetV2FormConfigurationUsecaseEnum = {
    Basic: 'basic',
    Pharmacy: 'pharmacy',
    VetDiet: 'vetDiet',
    Cwav: 'cwav',
    Insurance: 'insurance',
    Test: 'test'
} as const;
export type GetPetV2FormConfigurationUsecaseEnum = typeof GetPetV2FormConfigurationUsecaseEnum[keyof typeof GetPetV2FormConfigurationUsecaseEnum];
